import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import GoogleTagTracker from "./components/GoogleTagTracker";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Energiramme from "./pages/Energiramme";
import Energimaerkning from "./pages/Energimaerkning";
import Termografi from "./pages/Termografi";
import TermografiKomfortundersoegelse from "./pages/TermografiKomfortundersoegelse";
import Trykprovning from "./pages/Trykprovning";
import Prices from "./pages/Prices";
import Prisberegner from "./pages/Prisberegner";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";
import CityEnergikonsulent from "./pages/CityEnergikonsulent";
import CityEnergimaerkning from "./pages/CityEnergimaerkning";
import CityTrykprovning from "./pages/CityTrykprovning";
import { CITIES } from "./data/cities";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF9F6] text-stone-800 font-sans selection:bg-[#165B4C]/20 selection:text-[#165B4C]">
      <GoogleTagTracker />
      <ScrollToTop />
      <Navbar />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/energiramme" element={<Energiramme />} />
          <Route path="/energimaerkning" element={<Energimaerkning />} />
          <Route path="/termografi" element={<Termografi />} />
          <Route path="/termografi-komfortundersoegelse" element={<TermografiKomfortundersoegelse />} />
          <Route path="/termografi-og-komfortundersoegelse" element={<Navigate to="/termografi-komfortundersoegelse" replace />} />
          <Route path="/komfortundersoegelse" element={<Navigate to="/termografi-komfortundersoegelse" replace />} />
          <Route path="/trykproevning" element={<Trykprovning />} />
          {/* Alias for alternative spelling */}
          <Route path="/trykprovning" element={<Navigate to="/trykproevning" replace />} />

          {/* By-specifikke landingssider (uden menupunkter) */}
          {CITIES.map((city) => (
            <React.Fragment key={city.slug}>
              <Route
                path={`/energikonsulent-i-${city.slug}`}
                element={<CityEnergikonsulent cityProp={city} />}
              />
              <Route
                path={`/energimaerkning-i-${city.slug}`}
                element={<CityEnergimaerkning cityProp={city} />}
              />
              <Route
                path={`/trykproevning-i-${city.slug}`}
                element={<CityTrykprovning cityProp={city} />}
              />
              <Route
                path={`/trykprovning-i-${city.slug}`}
                element={<CityTrykprovning cityProp={city} />}
              />
            </React.Fragment>
          ))}

          <Route path="/priser" element={<Prices />} />
          <Route path="/prisberegner" element={<Prisberegner />} />
          <Route path="/galleri" element={<Gallery />} />
          <Route path="/galleri/:category" element={<Gallery />} />
          <Route path="/galleri-trykproevning" element={<Navigate to="/galleri/trykproevning" replace />} />
          <Route path="/galleri-termografi" element={<Navigate to="/galleri/termografi" replace />} />
          <Route path="/galleri-energiramme" element={<Navigate to="/galleri/energiramme" replace />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
